module.exports = {
      id: "microphone-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#microphone",
      toString: function () {
        return this.url;
      }
    }